import moment from 'moment';
import { pricesData } from '../data/pricesMick';

/* INFO:
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';
//export const subHiddenBreakpoint = 1440;
export const subHiddenBreakpoint = 1024;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';

// no more using
//export const browserLocale = navigator.language.substring(0, 2);

export const localeOptions = [
  { id: 'en', name: 'English', direction: 'ltr' },
  { id: 'it', name: 'Italiano', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
];

export const searchPath = '/app/account/search';
//export const servicePath = "https://api.coloredstrategies.com";

/* INFO:
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const themeColorStorageKey = '__theme_color';
export const isMultiColorActive = false;
export var defaultColor = 'light.blue';
export var isDarkSwitchActive = false;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';

export var maintenanceMode = false;
export var debugMode = false;
export var databaseType = '';
export var stripeIds = '';

export const loggedUsername = localStorage.getItem('username');
export const loggedDomain = loggedUsername && loggedUsername.split('@').pop();
export const adminUsername = localStorage.getItem('adminUsername');
export const adminDomain =
  adminUsername && adminUsername !== 'undefined'
    ? adminUsername.split('@').pop()
    : null;
export const user_id = localStorage.getItem('user_id');
export var isBlackAdmin = false;
export var isSuperAdmin = false;
export var isAdmin = false;
export var isDoctor = false;
export var demoUser;
export var demoUserId;
export var demoPatientId;
export var customStyleClass = '';   //includes custom logo for some views
export var platformName = 'MICK';
export var platformLogoPath = '/assets/img/logo-mick.png';
export var companyName = 'Sequentia Biotech SL';

//* CHECKING DATABASE IN USE
if (process.env.REACT_APP_USE_DEV_DB==='true') {
  databaseType = 'development';
} else {
  databaseType = 'production';
}

if (databaseType === 'production') {
  stripeIds = 'ids';
  demoUser = 'demo-admin@sequentiabiotech.com';
  demoUserId = '5ee0a7df34b6555967ea8e03';
  demoPatientId = '5f08625cbe1ba77117dff62b';
} else if (databaseType === 'development') {
  stripeIds = 'idsTest';
  demoUser = 'demo@demo.com';
  demoUserId = '606dc3c362130c2d6644fd60';
  demoPatientId = '606dc5e56994643319f24c40';
}

//* CHECKING ACCESS
export const access = JSON.parse(localStorage.getItem('access'));

//* CHECKING TRIAL STATUS
export const isTrialActive = JSON.parse(localStorage.getItem('trial'));
export const isOldUser = JSON.parse(localStorage.getItem('isOldUser'));

var accessLimit = localStorage.getItem('accessLimit');
var now = moment();
export var restTrialDays = now.diff(moment(accessLimit, 'DD/MM/YYYY'), 'days');

if (restTrialDays < 0) {
  restTrialDays = Math.abs(restTrialDays);
} else {
  restTrialDays = 0;
}
console.log('restTrialDays:---------->', restTrialDays);

//* CHECKING ACTIVE SUBSCRIPTION
export var activeSubscription = null;
export var activeSubscriptionLevel = null;
export var isSubActive = false;

const subscription = localStorage.getItem('sub');

if (subscription && pricesData && stripeIds) {
  // free subscriptions (like black admin, sequentiabiotech.com or demo accounts)
  if (subscription === 'unlimited') {
    activeSubscription = 'unlimited';
    activeSubscriptionLevel = -1;
    isSubActive = true;
  }

  if (subscription === 'none' || subscription === 'cancelled') {
    activeSubscription = 'none';
    activeSubscriptionLevel = -1;
    isSubActive = false;
  }

  if (isTrialActive) {
    activeSubscription = 'trial';
    activeSubscriptionLevel = -1;
    isSubActive = true;
  }

  // payed subscriptions
  if (
    pricesData['en'][0][stripeIds]['monthly'].includes(subscription) ||
    pricesData['en'][0][stripeIds]['annual'].includes(subscription)
  ) {
    activeSubscription = 'professional';
    activeSubscriptionLevel = 0;
    isSubActive = true;
  } else if (
    pricesData['en'][1][stripeIds]['monthly'].includes(subscription) ||
    pricesData['en'][1][stripeIds]['annual'].includes(subscription)
  ) {
    activeSubscription = 'studio';
    activeSubscriptionLevel = 1;
    isSubActive = true;
  } else if (
    pricesData['en'][2][stripeIds]['monthly'].includes(subscription) ||
    pricesData['en'][2][stripeIds]['annual'].includes(subscription)
  ) {
    activeSubscription = 'lab';
    activeSubscriptionLevel = 2;
    isSubActive = true;
  } else if (
    pricesData['en'][3][stripeIds]['monthly'].includes(subscription) ||
    pricesData['en'][3][stripeIds]['annual'].includes(subscription)
  ) {
    activeSubscription = 'corporate';
    activeSubscriptionLevel = 3;
    isSubActive = true;
  }
}

//* CHECKING ROLE
const role = localStorage.getItem('role');

if (role) {
  if (role === 'mick_admin') {
    isBlackAdmin = true;
    isDarkSwitchActive = true;
    defaultColor = 'dark.blue';
    // if (localStorage.getItem("__theme_color").indexOf("dark") !== -1 )
  } else if (role === 'super_admin') {
    isSuperAdmin = true;
  } else if (role === 'admin') {
    isAdmin = true;
  } else {
    isDoctor = true;
  }
}

//* CHECKING LOCATION
if (window.location.hostname.includes('testing')) {
  maintenanceMode = true;
  debugMode = true;
}

if (window.location.hostname === 'localhost') {
  maintenanceMode = true;
  debugMode = true;
}

//EYEMETAGENOMICS
if (window.location.hostname === 'lucy.eyemetagenomics.com') {
  customStyleClass = 'cstm-eyemetagenomics';
  platformLogoPath = "/assets/img/cstLogos/logo-lucy-eyemetagenomics-blue.png";
  platformName = 'LUCY';
  companyName = 'Eyemetagenomics';
}

export const isEyeMetagenomicsUser = loggedDomain === 'eyemetagenomics.com' || adminDomain === 'eyemetagenomics.com' ? true: false;

export const isSequentiaUser = ["admin@admin.com", "support@sequentiabiotech.com"].includes(loggedUsername) ? true : false